export default "__VITE_ASSET__CxnvEVak__"